import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/getByDocId`;
const url = `${PREFIX_URL}/inbox-documents/:fileId`;

type GetFileDetailsResponse = {
  data: any;
  status: boolean;
};

export const getFileDetails = (fileId: number): Promise<GetFileDetailsResponse> => {
  return axios.get(generateRoutePath(url, { fileId }));
};

export const fileDetailsKeys = {
  all: ['fileDetails'] as const,
  detail: ({ fileId }: { fileId: number }) =>
    [INBOX_API_KEY, ...fileDetailsKeys.all, fileId] as const,
};

type QueryFnType = typeof getFileDetails;

type useGetFileDetailsOptions = {
  fileId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useFileDetails = ({ fileId, config }: useGetFileDetailsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...fileDetailsKeys.all, fileId],
    queryFn: () => getFileDetails(fileId),
    staleTime: Infinity,
    ...config,
  });
};
